export default __webpack_public_path__ + "static/pr-newswire-240-034e2bc6bf978770bb13f60b20a060d8.png";